module.exports = __webpack_public_path__ + "img/email.608a563c.png";